module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/Renewals/renewals-grid/renewals-grid.component.css
// module id = ./src/app/recovery/Renewals/renewals-grid/renewals-grid.component.css
// module chunks = main